import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { NgModule } from '@angular/core';
import { MatTooltipModule as MatToolTipModule } from '@angular/material/tooltip';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { MaterialModule } from 'src/app/material.module';
import { Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ButtonV3Component, IconV3Component, InputV2Module, InputV3Component, PageContentLayoutComponent, PageFooterComponent, PageHeaderModule, RadioGroupV2Module, SearchBarV2Module, SelectV2Module, TableV2Module, TableV3Component } from '@gea/digital-ui-lib';
import { HrtFilterChipsComponent } from '../hrt-filter-chips/hrt-filter-chips.component';

@Component({
  selector: 'bookmark-popup',
  templateUrl: './hrt-bookmark.component.html',
  styleUrls: ['./hrt-bookmark.component.scss'],
  standalone: false,
})
export class HrtBookmarkComponent {
  constructor(
    public dialogRef: MatDialogRef<HrtBookmarkComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit() {
  }

  closePopup() {
    this.dialogRef.close(false);
  }
}

@NgModule({
  imports: [
    RouterModule,
    MaterialModule,
    BrowserModule,
    MatToolTipModule,
    FormsModule,
    InputV2Module,
    SelectV2Module,
    RadioGroupV2Module,
    IconV3Component,
    PageHeaderModule,
    SearchBarV2Module,
    TableV3Component,
    PageContentLayoutComponent,
    PageFooterComponent,
    InputV3Component,
    ButtonV3Component,
    HrtFilterChipsComponent
  ],
  exports: [HrtBookmarkComponent],
  declarations: [HrtBookmarkComponent],
})
export class HrtBookmarkModule {}
